// @ts-nocheck
import { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setInitialValues from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetInitialValues";
import setNavDrawerIsOpen from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetNavDrawerIsOpen";
import {
    getCurrencies,
    getFulfillmentLabel,
    getIsPunchOutSession,
    getLanguages,
    getSettingsCollection,
} from "@insite/client-framework/Store/Context/ContextSelectors";
import cancelPunchOut from "@insite/client-framework/Store/Context/Handlers/CancelPunchOut";
import setCurrency from "@insite/client-framework/Store/Context/Handlers/SetCurrency";
import setLanguage from "@insite/client-framework/Store/Context/Handlers/SetLanguage";
import signOut from "@insite/client-framework/Store/Context/Handlers/SignOut";
import { getHeader, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getWidgetsByPageId } from "@insite/client-framework/Store/Data/Widgets/WidgetSelectors";
import { getPageLinkByPageType, LinkModel, useGetLinks } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconProps } from "@insite/mobius/Icon";
import Globe from "@insite/mobius/Icons/Globe";
import MapPin from "@insite/mobius/Icons/MapPin";
import Drawer, { DrawerPresentationProps } from "@store/MobiusOverrides/Drawer/Drawer";
// import Menu from "@insite/mobius/Icons/Menu"; // Valtech Custom Code
// import User from "@insite/mobius/Icons/User"; // Valtech Custom Code
import { MappedLink } from "@insite/mobius/Menu";
// import PanelMenu, { PanelMenuPresentationProps } from "@insite/mobius/PanelMenu"; // Valtech Custom Code
import PanelRow, { PanelRowPresentationProps } from "@insite/mobius/PanelMenu/PanelRow";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import omitSingle from "@insite/mobius/utilities/omitSingle";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import React, { FC, useMemo } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css, useTheme } from "styled-components";

// Valtech Custom Code --->
import { useDisplayName } from "@store/Framework/Store/Foundation/Context/ContextHooks";
import Menu from "@store/Library/Components/Icons/Menu";
import Person from "@store/Library/Components/Icons/Person/PersonFill";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { headerIconButtonProps } from "@store/Themes/common/props/header";
import constant from "@store/constants";
import PanelMenu, { PanelMenuPresentationProps } from "@store/MobiusOverrides/PanelMenu/PanelMenu";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";

/* Store Custom Code = Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import StoreUser from "@store/Library/Components/Icons/StoreUser";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { IconWrapper } from "@insite/mobius/Icon";
import { IconPresentationProps } from "@insite/mobius/Icon/Icon";
import Language from "@store/Library/Components/Icons/Language";
/* Store Custom Code = End */

const LanguageMenu = getWidgetComponent("Common/LanguageMenu");

export interface CustomLinkModel extends LinkModel {
    openInNewWindow?: boolean;
    overriddenTitle?: boolean;
}
// <--- Valtech Custom Code

const mapStateToProps = (state: ApplicationState) => {
    const headerLinkListLinkFields =
        (getWidgetsByPageId(state, getHeader(state).id).find((widget: WidgetProps) => {
            return widget.type === "Header/HeaderLinkList";
        })?.fields.links as CustomLinkModel[]) ?? []; // Valtech Custom Code

    return {
        currencies: getCurrencies(state),
        currentCurrencyId: state.context.session.currency?.id,
        currentCurrencySymbol: state.context.session.currency?.currencySymbol,
        languages: getLanguages(state),
        currentLanguage: state.context.session.language,
        currentLocation: getLocation(state),
        isSigningIn: state.context.isSigningIn,
        userName: state.context.session?.userName,
        isGuest: state.context.session?.isGuest,
        myAccountPageLink: getPageLinkByPageType(state, "MyAccountPage"),
        signInUrl: getPageLinkByPageType(state, "SignInPage"),
        headerLinkListLinkFields,
        showCustomerMenuItem: getSettingsCollection(state).accountSettings.enableWarehousePickup,
        fulfillmentLabel: getFulfillmentLabel(state),
        drawerIsOpen: state.components.addressDrawer.navDrawerIsOpen,
        isPunchOutSession: getIsPunchOutSession(state),
    };
};

const mapDispatchToProps = {
    setCurrency,
    setLanguage,
    signOut,
    cancelPunchOut,
    setInitialValues,
    setNavDrawerIsOpen,
};

interface OwnProps {
    links: MappedLink[];
    showQuickOrder: boolean;
    quickOrderLink: PageLinkModel | undefined;
}
type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export interface NavigationDrawerStyles {
    menuTriggerButton?: ButtonPresentationProps;
    drawer?: DrawerPresentationProps;
    drawerSectionWrapper?: InjectableCss;
    panelMenu?: PanelMenuPresentationProps;
    panelSectionWrapper?: InjectableCss;
    menuRowIcon?: IconProps;
    userRowTypography?: TypographyPresentationProps;
    punchOutUserRowText?: TypographyPresentationProps;
    mainNavigationRow?: PanelRowPresentationProps;
    mainNavigationRowIcon?: IconProps;
    punchOutNavigationRowIcon?: IconProps;
    mainNavigationRowTypography?: TypographyPresentationProps;
    logoLinks?: PanelRowPresentationProps & { typographyProps: TypographyPresentationProps };
    currencySymbol?: TypographyPresentationProps;
    changeCustomerRow?: PanelRowPresentationProps;
    changeCustomerRowContainer?: GridContainerProps;
    fulfillmentMethodGridItem?: GridItemProps;
    addressesGridItem?: GridItemProps;
    pickUpAddressGridItem?: GridItemProps;
    applyButtonGridItem?: GridItemProps;
    signOutRow?: PanelRowPresentationProps;
    signOutRowText?: TypographyPresentationProps;
    // Valtech Custom Code
    menuIcon?: IconProps;
    languageMenu?: LinkPresentationProps;
    // Store Custom Code
    mainPanelMenu?: PanelMenuPresentationProps;
    userRowLabelTypography?: TypographyPresentationProps;
    userRowTypographyWrapper?: InjectableCss;
    secondaryPanelMenu?: PanelMenuPresentationProps;
    secondaryNavigationRow?: PanelRowPresentationProps;
    tertiaryRowTypography?: TypographyPresentationProps;
    loginNavigationRow?: PanelRowPresentationProps;
    languageMenuWrapper?: InjectableCss;
    languageIcon?: IconPresentationProps;
}

const StyledSection = getStyledWrapper("section");
const StyledSpan = getStyledWrapper("span");

// Valtech Custom Code
const drawerContentWidth = [100, 60, 40];
// Valtech Custom Code

export const navigationDrawerStyles: NavigationDrawerStyles = {
    menuTriggerButton: headerIconButtonProps,
    drawer: {
        size: 400,
        cssOverrides: {
            drawerContainer: css`
                max-width: 340px; /* Store Custom Code */
            `,
            drawerContent: css`
                position: relative;
                width: 100%;
                overflow: hidden;
                margin-top: -2px;

                > * {
                    height: 100%;
                    background-color: ${getColor("common.background")};
                }
            `,
            drawerBody: css`
                display: flex;
                flex-direction: column; /* Store Custom Code */
                overflow: hidden;
                background-color: ${getColor("common.background")}; /* Store Custom Code */
                box-shadow: none;
            `,
            drawerTitle: css`
                align-items: baseline;
                padding: 0;
                margin-left: auto;
                background-color: transparent;

                /* Store Custom Code - Start */
                > button {
                    background-color: ${getColor("primary")};
                    color: ${getColor("primary.contrast")};

                    &:focus {
                        outline: none;
                        background-color: ${getColor("secondary")};
                    }
                }

                /* Store Custom Code - End */
            `,
            titleButton: css`
                display: flex;
                justify-content: center;
                align-items: center;
                width: 40px;
                height: 40px;
                border-radius: 0;
                border: none;
                background: ${getColor("primary")};
                outline: none;
            `,
        },
    },
    drawerSectionWrapper: {
        css: css`
            &:first-child {
                margin-top: 0;
                padding-bottom: 10px;
                background: ${getColor("common.shadesLight")}; /* Store Custom Code */
            }
            margin-top: 20px;
        `,
    },
    panelMenu: {
        cssOverrides: {
            wrapper: css`
                > button {
                    width: 100%; /* Store Custom Code */
                }
            `,
        },
    },
    panelSectionWrapper: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    menuRowIcon: {
        size: 22,
        css: css`
            margin-top: -2px;
            margin-right: 10px;
            width: 24px;
            display: inline-block;
            text-align: center;
            vertical-align: middle;
        `,
    },
    userRowTypography: {
        color: "secondary.contrast",
        css: css`
            font-weight: ${({ theme }) => theme.design.typography.weight.bold}; /* Store Custom Code */
            font-size: ${({ theme }) => theme.design.typography.size.smaller}; /* Store Custom Code */
        `,
    },
    punchOutUserRowText: {
        transform: "capitalize",
        color: "primary",
        css: css`
            font-weight: ${({ theme }) => theme.design.typography.weight.medium};
        `,
    },
    mainNavigationRow: {},
    mainNavigationRowIcon: {
        src: StoreUser, // Store Custom Code
        color: "secondary.contrast", // Store Custom Code
        size: 22,
        css: css`
            margin-top: -2px;
            margin-right: 10px;
            width: 24px;
            display: inline-block;
            text-align: center;
            vertical-align: middle;
            color: ${getColor("secondary.contrast")}; /* Store Custom Code */
        `,
    },
    punchOutNavigationRowIcon: {
        src: Person,
        color: "primary",
        size: 22,
        css: css`
            margin-top: -2px;
            margin-right: 10px;
            width: 24px;
            display: inline-block;
            text-align: center;
            vertical-align: middle;
        `,
    },
    mainNavigationRowTypography: {
        transform: "capitalize",
        color: "text", // Store Custom Code
        css: css`
            font-weight: ${({ theme }) => theme.design.typography.weight.bold}; /* Store Custom Code */
            font-size: ${({ theme }) => theme.design.typography.size.large}; /* Store Custom Code */
        `,
    },
    logoLinks: {
        color: "common.background",
        typographyProps: {
            ellipsis: true,
            transform: "capitalize",
        },
        css: css`
            margin: 2px;
        `,
    },
    currencySymbol: {
        size: 22,
        css: css`
            margin-top: -4px;
            margin-right: 10px;
            width: 24px;
            display: inline-block;
            text-align: center;
            vertical-align: middle;
        `,
    },
    changeCustomerRow: {
        css: css`
            &:focus {
                outline: none;
            }
        `,
    },
    changeCustomerRowContainer: { gap: 15 },
    fulfillmentMethodGridItem: { width: 12 },
    addressesGridItem: { width: 12 },
    pickUpAddressGridItem: { width: 12 },
    applyButtonGridItem: { width: 12 },
    /* Store Custom Code - Start */
    signOutRow: {
        css: css`
            font-size: ${({ theme }) => theme.design.typography.size.smallest};
            color: ${getColor("primary")};
            font-weight: ${({ theme }) => theme.design.typography.weight.bold};
        `,
    },
    /* Store Custom Code - End */
    signOutRowText: {
        transform: "uppercase",
    },
    menuIcon: {
        color: "primary",
        size: 28,
        css: css`
            ${transitionHoverStyles()}

            &:hover {
                color: ${getColor("secondary")};
            }
        `,
    },
    /* Store Custom Code - Start */
    mainPanelMenu: {
        cssOverrides: {
            wrapper: css`
                background-color: ${getColor("secondary")};

                > button {
                    width: 100%;
                    background: transparent;
                    color: ${getColor("secondary.contrast")};
                    :hover * {
                        color: ${getColor("secondary.contrast")};
                        > ${IconWrapper} {
                            color: ${getColor("secondary.contrast")};
                        }
                    }
                    > ${IconWrapper} {
                        color: ${getColor("secondary.contrast")};
                    }
                }
            `,
        },
    },
    userRowLabelTypography: {
        css: css`
            font-size: ${({ theme }) => theme.design.typography.size.smallest};
        `,
    },
    userRowTypographyWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    secondaryPanelMenu: {
        cssOverrides: {
            wrapper: css`
                background-color: ${getColor("common.background")};

                > button {
                    width: 100%;
                    background: transparent;
                }
            `,
        },
    },
    secondaryNavigationRow: {
        css: css`
            background-color: ${getColor("common.background")};
            padding: ${x => x.theme.design.layout.spacing.small};
        `,
    },
    tertiaryRowTypography: {
        css: css`
            font-size: ${({ theme }) => theme.design.typography.size.smaller};
        `,
    },
    loginNavigationRow: {
        isCurrentCss: css`
            background-color: ${getColor("secondary")};
        `,
        css: css`
            background-color: ${getColor("secondary")};
            padding: ${pxToRem(18, 16)};
        `,
    },
    languageMenuWrapper: {
        css: css`
            font-size: ${({ theme }) => theme.design.typography.size.smaller};
            display: flex;
        `,
    },
    languageIcon: {
        size: 22,
        src: Language,
        css: css`
            margin-right: ${pxToRem(5)};
        `,
    },
    /* Store Custom Code - End */
};

const styles = navigationDrawerStyles;

const NavigationDrawer: FC<Props> = props => {
    const headerLinkListLinks = useGetLinks(props.headerLinkListLinkFields, o => o.fields.destination);
    const openDrawer = () => {
        props.setNavDrawerIsOpen({ navDrawerIsOpen: true });
        props.setInitialValues({});
    };

    const closeDrawer = () => {
        props.setNavDrawerIsOpen({ navDrawerIsOpen: false });
        setTimeout(() => props.setNavDrawerIsOpen({ navDrawerIsOpen: undefined }), 300);
    };

    const onSignOutHandler = () => {
        props.setNavDrawerIsOpen({ navDrawerIsOpen: false });
        props.isPunchOutSession ? props.cancelPunchOut() : props.signOut();
    };

    const {
        quickOrderLink,
        links,
        showQuickOrder,
        currencies,
        currentCurrencyId,
        currentCurrencySymbol,
        languages,
        currentLanguage,
        setLanguage,
        setCurrency,
        userName,
        isGuest,
        myAccountPageLink,
        signInUrl,
        currentLocation,
        showCustomerMenuItem,
        fulfillmentLabel,
        isPunchOutSession,
        headerLinkListLinkFields,
        history,
    } = props;
    const currentPageUrl = currentLocation.pathname;

    // Valtech Custom Code
    const displayName = useDisplayName();
    // Valtech Custom Code

    const tabDisabled = -1;
    return (
        <>
            <Button
                onClick={openDrawer}
                aria-label={translate("menu")}
                {...styles.menuTriggerButton}
                data-test-selector="expandMobileMenu"
            >
                <ButtonIcon src={Menu} {...styles.menuIcon} /> {/* Valtech Custom Code */}
            </Button>
            <Drawer
                draggable
                position="left"
                {...styles.drawer}
                isOpen={props.drawerIsOpen}
                handleClose={closeDrawer}
                contentLabel="menu drawer"
            >
                <StyledSection {...styles.drawerSectionWrapper}>
                    {userName && !isGuest && !isPunchOutSession ? (
                        <PanelMenu
                            currentUrl={currentPageUrl}
                            panelTrigger={
                                <PanelRow hasChildren {...styles.mainNavigationRow}>
                                    <StyledSpan {...styles.panelSectionWrapper}>
                                        <Icon {...styles.mainNavigationRowIcon} />
                                        {/* Store Custom Code - Start */}
                                        <StyledWrapper {...styles.userRowTypographyWrapper}>
                                            <Typography {...styles.userRowLabelTypography}>
                                                {translate("My Account")}
                                            </Typography>
                                            <Typography {...styles.userRowTypography}>
                                                {displayName /* Valtech Custom Code */}
                                            </Typography>
                                        </StyledWrapper>
                                        {/* Store Custom Code - End */}
                                    </StyledSpan>
                                </PanelRow>
                            }
                            menuItems={myAccountPageLink?.children ? myAccountPageLink?.children : []}
                            /* Valtech Custom Code */
                            maxDepth={1}
                            /* Valtech Custom Code */
                            closeOverlay={closeDrawer}
                            layer={0}
                            {...styles.mainPanelMenu} // Store Custom Code
                        />
                    ) : isPunchOutSession ? (
                        <PanelRow {...styles.mainNavigationRow}>
                            <StyledSpan {...styles.panelSectionWrapper}>
                                <Icon {...styles.punchOutNavigationRowIcon} />
                                <Typography {...styles.punchOutUserRowText}>{userName}</Typography>
                            </StyledSpan>
                        </PanelRow>
                    ) : (
                        <PanelRow
                            {...styles.loginNavigationRow} // Store Custom Code
                            isCurrent={currentPageUrl === signInUrl?.url}
                            onClick={closeDrawer}
                            onKeyPress={(event: React.KeyboardEvent) => {
                                if (event.key === " " && history && signInUrl?.url) {
                                    event.preventDefault();
                                    closeDrawer();
                                    history.push(signInUrl.url);
                                }
                            }}
                            href={signInUrl?.url}
                        >
                            <StyledSpan {...styles.panelSectionWrapper}>
                                <Icon {...styles.mainNavigationRowIcon} />
                                {/* Valtech Custom Code */}
                                <Typography {...styles.userRowTypography}>{translate("Login")}</Typography>
                            </StyledSpan>
                        </PanelRow>
                    )}
                    {/* covers MainNavigation functionality */}

                    {links.map((link, index) => {
                        if (link.children && link.children.length > 0) {
                            return (
                                <PanelMenu
                                    // eslint-disable-next-line react/no-array-index-key
                                    key={`${index}${link.title}`}
                                    currentUrl={currentPageUrl}
                                    closeOverlay={closeDrawer}
                                    panelTrigger={
                                        <PanelRow hasChildren {...styles.mainNavigationRow}>
                                            <Typography {...styles.mainNavigationRowTypography}>
                                                {link.title}
                                            </Typography>
                                        </PanelRow>
                                    }
                                    menuItems={link.children}
                                    maxDepth={link.maxDepth || 3}
                                    layer={0}
                                    {...styles.panelMenu}
                                    parent={link.title} // Valtech Custom Code
                                    {...styles.secondaryPanelMenu} // Store Custom Code
                                />
                            );
                        }
                        return (
                            <PanelRow
                                // eslint-disable-next-line react/no-array-index-key
                                key={`${index}${link.title}`}
                                href={link.url}
                                target={link.openInNewWindow ? "_blank" : ""}
                                {...styles.mainNavigationRow}
                            >
                                <Typography {...styles.mainNavigationRowTypography}>{link.title}</Typography>
                            </PanelRow>
                        );
                    })}
                    {/* Valtech Custom Code */}
                    {showQuickOrder && quickOrderLink && (
                        <PanelRow
                            isCurrent={currentPageUrl === quickOrderLink.url}
                            onClick={closeDrawer}
                            href={quickOrderLink.url}
                            {...styles.secondaryNavigationRow}
                        >
                            <Typography {...styles.mainNavigationRowTypography}>{quickOrderLink.title}</Typography>
                        </PanelRow>
                    )}
                    {headerLinkListLinks.length > 0 ? (
                        headerLinkListLinks.map((link, index) => (
                            <PanelRow
                                // bunzl custom code added unique key
                                key={`${link.title}-${index}`}
                                {...styles.mainNavigationRow}
                                isCurrent={currentPageUrl === link.url}
                                onClick={closeDrawer}
                                href={link.url}
                                target={headerLinkListLinkFields[index].openInNewWindow ? "_blank" : ""}
                            >
                                <Typography {...styles.tertiaryRowTypography} /* Store Custom Code */>
                                    {
                                        props.headerLinkListLinkFields[index].fields.overriddenTitle ||
                                            link.title /* Valtech Custom Code  */
                                    }
                                </Typography>
                            </PanelRow>
                        ))
                    ) : (
                        <></>
                    )}
                    {languages?.length && languages?.length > 1 ? (
                        /* Store Custom Code - Start */
                        <PanelRow tabIndex={tabDisabled}>
                            <StyledWrapper {...styles.languageMenuWrapper}>
                                <Icon {...styles.languageIcon} />
                                <LanguageMenu displayName {...styles.languageMenu} />
                            </StyledWrapper>
                        </PanelRow>
                    ) : /* Store Custom Code - End */
                    null}
                    {/* Valtech Custom Code */}
                    {/* Valtech Removed Code - QuickOrder - Native HeaderLinkList - Native Language Selector */}
                    {userName && !isGuest && (
                        <PanelRow onClick={onSignOutHandler} {...styles.signOutRow}>
                            <Typography>
                                {isPunchOutSession ? translate("Cancel PunchOut") : translate("Sign Out")}
                            </Typography>
                        </PanelRow>
                    )}
                </StyledSection>
            </Drawer>
        </>
    );
};

const LogoImage = styled.img`
    margin-right: 10px;
    height: 22px;
`;

interface SelectorMenuProps {
    options?: MappedLink[];
    closeModal?: () => void;
    currentOption: React.ReactNode;
    currentOptionIcon: React.ReactNode;
    dataTestSelector?: string;
}

const SelectorMenu: React.FC<SelectorMenuProps> = ({
    options,
    closeModal,
    currentOption,
    currentOptionIcon,
    dataTestSelector,
}) => {
    if (!options || options.length <= 1) {
        return null;
    }

    const trigger = (
        <PanelRow hasChildren {...styles.logoLinks}>
            <StyledSpan {...styles.panelSectionWrapper}>
                {currentOptionIcon}
                <Typography
                    data-test-selector={`${dataTestSelector}_currentOption`}
                    {...styles.logoLinks?.typographyProps}
                >
                    {currentOption}
                </Typography>
            </StyledSpan>
        </PanelRow>
    );

    return (
        <PanelMenu
            data-test-selector={dataTestSelector}
            closeOverlay={closeModal}
            panelTrigger={trigger}
            menuItems={options}
            maxDepth={1}
            layer={0}
            {...styles.panelMenu}
        />
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withHistory(NavigationDrawer));
